import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {WARNING_SLICE} from './constants';
import {TSetWarningVisibilityPayload, IWarningModuleState} from './types';

const initialState: IWarningModuleState = {
    warningInitialState: {},
};

export const warningSlice = createSlice({
    initialState,
    name: WARNING_SLICE,
    reducers: {
        setWarningVisibility(state, {payload}: PayloadAction<TSetWarningVisibilityPayload>) {
            state[payload.entityName] = {
                ...state[payload.entityName],
                visible: payload.warningVisible,
            };
        },

    },
});

export const {reducer: warningSliceReducer} = warningSlice;

export const {setWarningVisibility} = warningSlice.actions;
